import { Box, Tab, Tabs, styled, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useTranslation } from '../../services/translation/hooks/useTranslation';
import {
  RanchPageViewEnum,
  selectRanchPageView,
} from '../ranches/ranchesSlice';
import {
  RanchViewFeaturesEnum,
  selectCurrRanchViewFeature,
  setCurrRanchViewFeature,
} from './selectSlice';
const tabHeight = '40px';

const StyledTab = styled(Tab)(({ theme }) => ({
  height: tabHeight,
  minWidth: 'min-content',
  color: theme.colors.common.white,
  backgroundColor: theme.colors.canopy.grey[25],
  '&.Mui-selected': {
    color: theme.colors.common.white,
    backgroundColor: theme.colors.canopy.invert,
  },
  font: 'inherit',
}));

const MapTableViewToggle: React.FC = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const currRanchViewFeature = useAppSelector(selectCurrRanchViewFeature);
  const ranchPageView = useAppSelector(selectRanchPageView);

  return ranchPageView === RanchPageViewEnum.ranchSummary ? (
    <Box
      sx={{
        width: 'min-content',
        minWidth: 'min-content',
        bgcolor: theme.colors.darkTheme.grey.medium,
        borderRadius: theme.borderRadius.primary,
        border: `1px solid ${theme.colors.canopy.grey[200]}`,
        overflow: 'hidden', // Ensures the border radius is applied properly
        mr: theme.spacing(2.5),
      }}
    >
      <Tabs
        value={currRanchViewFeature}
        onChange={(event, newValue) =>
          dispatch(setCurrRanchViewFeature(newValue))
        }
        sx={{
          height: tabHeight,
          minHeight: tabHeight,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '& .MuiTabs-indicator': {
            backgroundColor: 'transparent', // hide the underline tab indicator
          },
          '& .MuiButtonBase-root': {
            height: tabHeight,
          },
        }}
      >
        <StyledTab
          label={t('map', { ns: 'common' })}
          value={RanchViewFeaturesEnum.RanchMap}
          sx={{
            borderRight: `1px solid ${theme.colors.canopy.grey[200]}`,
          }}
        />
        <StyledTab
          label={t('table', { ns: 'common' })}
          value={RanchViewFeaturesEnum.Tables}
        />
      </Tabs>
    </Box>
  ) : null;
};

export default MapTableViewToggle;
